import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { IModalBase, initialDataList } from '@interfaces/common/common.Interface'

export interface UserState {
  userList: any
  userTuyChonList?: any
  userChiTiet?: any
  reloadUserList?: string | null
  modalUser?: IModalBase

  vaiTroList: any
  duAnList: any
  chiNhanhCuaToiList: any
  duAnCuaToiList: any
}

const initialState: UserState = {
  userList: initialDataList,
  userTuyChonList: initialDataList,
  userChiTiet: {},
  reloadUserList: null,
  modalUser: {
    visible: false,
    record: {}
  },
  vaiTroList: initialDataList,
  duAnList: initialDataList,
  chiNhanhCuaToiList: initialDataList,
  duAnCuaToiList: initialDataList,
}

export const userDucks: any = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state: RootState) => {
      state.responseLogin = { loading: true, error: false }
    },
    loginSuccess: (state: RootState, { payload: responseLogin }) => {
      state.responseLogin = {
        loading: false,
        error: false,
        response: responseLogin,
      }
    },
    loginFail: (state: RootState, { payload: error }) => {
      state.responseLogin = {
        loading: false,
        error: true,
        response: error,
      }
    },

    getListUser: (state: RootState) => {
      state.userList = { loading: true }
    },
    getListUserSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.userList = { loading: false, ...action.payload }
    },
    getListUserFail: (state: RootState, action: PayloadAction<any>) => {
      const err = action.payload
      state.userList = {
        loading: false,
        data: [],
        paging: { page: 1, pageSize: 20, total: 0 },
        message: typeof err === 'object' && err && 'message' in err ? (err as any).message : String(err ?? 'Error'),
      }
    },

    getListOptionUser: (state: RootState) => {
      state.userTuyChonList = { loading: true }
    },
    getListOptionUserSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.userTuyChonList = { loading: false, ...action.payload }
    },
    getListOptionUserFail: (state: RootState, action: PayloadAction<any>) => {
      state.userTuyChonList = { loading: false, ...action.payload }
    },

    getDetailUser: (state: RootState, action: PayloadAction<any>) => {
      state.userChiTiet = { loading: true, id: action.payload }
    },
    getDetailUserSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.userChiTiet = { loading: false, ...action.payload }
    },
    getDetailUserFail: (state: RootState, action: PayloadAction<any>) => {
      state.userChiTiet = { loading: false, ...action.payload }
    },

    setReloadUserList: (state: RootState) => {
      state.reloadUserList = String(Date.now())
    },
    setModalUser: (state: RootState, action: PayloadAction<IModalBase>) => {
      state.modalUser = action.payload
    },

    getListRole: (state: RootState) => {
      state.vaiTroList = { loading: true }
    },
    getListRoleSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.vaiTroList = { loading: false, ...action.payload }
    },
    getListRoleFail: (state: RootState, action: PayloadAction<any>) => {
      state.vaiTroList = { loading: false, ...action.payload }
    },

    getListProject: (state: RootState) => {
      state.duAnList = { loading: true }
    },
    getListProjectSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },
    getListProjectFail: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },

    getListMyDuAn: (state: RootState) => {
      state.duAnCuaToiList = { loading: true }
    },
    getListMyDuAnSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.duAnCuaToiList = { loading: false, ...action.payload }
    },
    getListMyDuAnFail: (state: RootState, action: PayloadAction<any>) => {
      state.duAnCuaToiList = { loading: false, ...action.payload }
    },

    getListMyChiNhanh: (state: RootState) => {
      state.chiNhanhCuaToiList = { loading: true }
    },
    getListMyChiNhanhSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhCuaToiList = { loading: false, ...action.payload }
    },
    getListMyChiNhanhFail: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhCuaToiList = { loading: false, ...action.payload }
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  login,
  loginSuccess,
  loginFail,

  getListUser,
  getListUserSuccess,
  getListUserFail,

  getListOptionUser,
  getListOptionUserSuccess,
  getListOptionUserFail,

  getDetailUser,
  getDetailUserSuccess,
  getDetailUserFail,

  setReloadUserList,
  setModalUser,

  getListRole,
  getListRoleSuccess,
  getListRoleFail,

  getListProject,
  getListProjectSuccess,
  getListProjectFail,

  getListMyDuAn,
  getListMyDuAnSuccess,
  getListMyDuAnFail,

  getListMyChiNhanh,
  getListMyChiNhanhSuccess,
  getListMyChiNhanhFail,
} =
  userDucks.actions

export default userDucks.reducer

